import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import throttle from 'lodash/throttle';
import { getScrollPositionFromElement } from '../utils';

type OwnProps = {
  onScrollCallback: () => void;
};

const ScrollHandler = ({ onScrollCallback }: OwnProps) => {
  const location = useLocation();

  const handleScroll = throttle(() => {
    onScrollCallback();
  }, 400);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  useEffect(() => {
    const element = document.getElementById(location.hash);

    if (!element) return;

    setTimeout(() => {
      window.scrollTo({
        behavior: element ? 'smooth' : 'auto',
        top: getScrollPositionFromElement(element),
      });
    }, 100);
  }, [location]);

  return null;
};

export default ScrollHandler;
